import { render, staticRenderFns } from "./DrmAd.vue?vue&type=template&id=90c92b78&scoped=true"
import script from "./DrmAd.vue?vue&type=script&lang=js"
export * from "./DrmAd.vue?vue&type=script&lang=js"
import style0 from "./DrmAd.vue?vue&type=style&index=0&id=90c92b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c92b78",
  null
  
)

export default component.exports